import React from "react";
import { ContainerWrapper } from "../../common/ContainerWrapper";
import { Breadcrumbs, IconButton, Stack, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { BillingForm } from "./BillingForm";
import { upperFirst } from "lodash";
import { validPlan } from "./constant";

export const BillingCheckout = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const plan = searchParams.get("plan");
  const isValidPlan = validPlan.includes(plan);
  const onHandleBack = () => {
    navigate("/Billing");
  };
  return (
    <ContainerWrapper gap={2}>
      <Stack direction={"row"} alignItems={"center"} gap={2}>
        <IconButton
          sx={{
            borderRadius: ".65rem",
            border: "1px solid #E6E9EC",
            background: "#F7F7F7",
          }}
          size="small"
          onClick={onHandleBack}
        >
          <ChevronLeftIcon sx={{ color: "#415058" }} />
        </IconButton>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline="hover"
            color="#415058"
            fontWeight={500}
            href="/Billing"
          >
            Billing
          </Link>
          <Stack direction={"row"} gap={0.5} alignItems={"center"}>
            <CreditCardIcon sx={{ color: "#415058" }} />
            <Typography color="#415058" fontWeight={700}>
              {isValidPlan ? upperFirst(plan) : "-"} Plan
            </Typography>
          </Stack>
        </Breadcrumbs>
      </Stack>
      <Typography pb={2.5}>
        Complete your payment to start your subscription.
      </Typography>
      <BillingForm />
    </ContainerWrapper>
  );
};

export default BillingCheckout;
